const data = {
  success: '',
  error: '',
  user: {},
  users: [],
  unauthorized: false,
  forbidden: false,
  forbiddenMessage: '',
  unAuthorizedMessage: '',
  allUsers: [],
  role: 'member',
  pinned: [],
};

const userReducer = (state = data, action) => {
  switch (action.type) {
    case 'successUser':
      return {
        ...state,
        success: action.payload,
      };

    case 'success-get':
      return {
        ...state,
        users: action.payload,
      };

    case 'userError':
      return {
        ...state,
        error: action.payload,
      };

    case 'user':
      return {
        ...state,
        user: action.payload,
      };

    case 'confirmEmail': {
      return {
        ...state,
        user: { ...state.user, isVerified: true }
      }
    }
    case 'unauthorizedError':
      return {
        ...state,
        unauthorized: true,
        unAuthorizedMessage: action.payload
      }

    case 'clearUnauthorizedError':
      return {
        ...state,
        unauthorized: false
      }

    case 'forbiddenError':
      return {
        ...state,
        forbidden: true,
        forbiddenMessage: action.payload
      }

    case 'clearForbiddenError':
      return {
        ...state,
        forbidden: false
      }

    case 'setAllUsers':
      return {
        ...state,
        allUsers: action.append ? [...(state.allUsers || []), ...action.payload] : action.payload,
        allUsersTotal: action.total ?? state.allUsersTotal ?? 0,
      }

    case 'set-workspace-role':
      const me = action?.payload?.find(member => member?._id == state?.user?._id);

      return {
        ...state,
        role: me?.role
      }

    case 'set-pinned-items':
      return {
        ...state,
        pinned: action.payload,
      };

    case 'toggle-pin-item': {
      const { data, isPinned, entity } = action.payload;
      const currentItems = state.pinned || [];

      let updatedPinned;
      if (!isPinned) {
        updatedPinned = currentItems.filter(item => item._id !== data.entityId);
      } else {
        const alreadyExists = currentItems.some(item => item._id === data.entityId);
        updatedPinned = alreadyExists ? currentItems : [...currentItems, entity];
      }

      return {
        ...state,
        pinned: updatedPinned
      };
    }

    case 'update-pin-project-settings': {
      const { _id, title, access, archived } = action.payload;

      return {
        ...state,
        pinned: state.pinned.map(item =>
          item._id === _id
            ? {
              ...item,
              name: title,
              access: access,
              archived: archived
            }
            : item
        )
      };
    }

    case 'update-pin-portfolio-data': {
      const { portfolioId, projects, name, access } = action.payload;
      return {
        ...state,
        pinned: state.pinned.map(item =>
          item?._id === portfolioId
            ? {
              ...item,
              ...(projects
                ? item.children
                  ? { children: [...(item.children || []), ...projects] }
                  : { projects: [...(item.projects || []), ...projects] }
                : {}),
              ...(name ? { name } : {}),
              ...(access ? { access } : {})
            }
            : item
        )
      };
    }

    case 'delete-pin-portfolio-projects': {
      const { portfolioId, projects } = action.payload;
      return {
        ...state,
        pinned: state.pinned.map(item =>
          item?._id === portfolioId
            ? {
              ...item,
              ...(item.children ? { children: item.children.filter(proj => proj && !projects.includes(proj?._id)) }
                : { projects: item.projects.filter(proj => proj && !projects.includes(proj._id)) })
            } : item
        )
      };
    }

    case 'delete-portfolio-pinned': {
      const portfolioId = action.payload;

      return {
        ...state,
        pinned: state.pinned.filter(item => item._id !== portfolioId),
      };
    }

    case 'update-pin-portfolio': {
      const { portfolioId, name, access } = action.payload;
      return {
        ...state,
        pinned: state.pinned.map(item =>
          item?._id === portfolioId
            ? {
              ...item,
              ...(name ? { name } : {}),
              ...(access ? { access } : {})
            }
            : item
        )
      };
    }

    default:
      return state;
  }
};
export default userReducer;
